__turbopack_context__.v({
  "className": "ekmodenaextendedheavy_12b5fcbf-module__JpsOfa__className",
  "variable": "ekmodenaextendedheavy_12b5fcbf-module__JpsOfa__variable",
});
